import { APP_INITIALIZER, enableProdMode, importProvidersFrom } from '@angular/core';
import './polyfills';
import { environment } from './environments/environment';
import { AppComponent } from './app/app.component';
import { routes } from './app/app-routes';
import { HttpClient, withInterceptorsFromDi, provideHttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import { RouteReuseStrategy, provideRouter } from '@angular/router';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import {
  IonicRouteStrategy,
  provideIonicAngular,
} from '@ionic/angular/standalone';
import { VaultService } from './app/services/vault.service';
import { HttpConfigInterceptor } from './app/services/http-interceptor';
import { registerNotificationActions } from './app/services/notification.initializer';
if (environment.production && environment.envName == 'prod') {
  enableProdMode();
  if (window) {
    // window.console.log = window.console.warn = window.console.info = () => { }
  }
}
export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

bootstrapApplication(AppComponent, {
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
  { provide: APP_INITIALIZER, useFactory: registerNotificationActions, multi: true },
    importProvidersFrom(
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: createTranslateLoader,
          deps: [HttpClient],
        },
      })
    ),
    VaultService,
    provideIonicAngular(),
    provideRouter(routes),
    provideHttpClient(withInterceptorsFromDi()),
    { provide: HTTP_INTERCEPTORS, useClass: HttpConfigInterceptor, multi: true }
  ],
});
